import { HttpClient } from '@angular/common/http';
import { Injectable, } from '@angular/core';
import { environment } from 'src/environments/environment';
import { IEditGlobalSearchField } from '../models/global-search-config.model';

@Injectable({
    providedIn: 'root'
})

export class GlobalSearchConfigService {

    constructor(private http: HttpClient){}

    fetchGloablSearchData(typeId: number){
        return this.http.get<any>(`${environment.configUrl}v2/FeatureConfiguration/GlobalSearch`)
        .toPromise()
        .then((res) => res);
    }

    updateGloablSeachField(updateData: IEditGlobalSearchField){
        return this.http.post<any>(`${environment.configUrl}v2/FeatureConfiguration/GlobalSearch`, updateData)
        .toPromise()
        .then((res) => res);
    }

   

}